import $ from "jquery";
import "slick-carousel";

$(".js-image-slider").each(function () {
  const $block = $(this);

  const $track = $block.find(".js-image-slider__track");
//   const $prev = $block.find(".js-slider-arrow-prev");
//   const $next = $block.find(".js-slider-arrow-next");
  const $dots = $block.find(".js-image-slider__dots");

  $track.slick({
    infinite: true,
    centerMode: true,
    autoplay: false,
    // slidesToShow: 3,
    // slidesToScroll: 1,
    variableWidth: true,
    dots: true,
    dotsClass: "",
    appendDots: $dots,
    draggable: true,
    adaptiveHeight: true,
	arrows: false,
    // nextArrow: $next,
    // prevArrow: $prev,
    fade: false,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          centerMode: false,
          variableWidth: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
        },
      },
    ],
  });
});
